import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  columns: 3,
  maxColumns: 10,
  hideInactiveLanes: false,
  includeHCP: false,
  includeGameTotal: true,
  showPinLeaves: false,
  lanes: [],
  followPlayers: [],
};

const useSettingsStore = create(
  persist(
    (set) => ({
      ...initialState,
      onUpdateSettings: (setting, value) => set({ [setting]: value }),
    }),
    {
      name: 'lt-settings',
    }
  )
);

export default useSettingsStore;
